<template>
    <div id="header" class="mx-auto bg-center bg-cover">
        <Navbar/>
        <Intro/>
    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Intro from '../components/Intro.vue'
export default {
    components: { Navbar, Intro }
}
</script>

<style scoped>
    #header{
        background-image: url('../assets/img/bg.jpg');
    }
</style>